module.exports = __webpack_public_path__ + "img/loupe.55e2f36d.svg";